class ProductPage{
    constructor(){
        this.init()
    }

    clickEvent = () =>{
        let styles = document.querySelectorAll('.product-styles .style-item');
        styles.forEach((item)=>{
            item.addEventListener('click',(e)=>{
                let msg = document.querySelector('.stye-error-msg');
                msg.classList.remove('active')
                let img = item.querySelector('img');
                let boxes = document.querySelectorAll('.style-item-box');
                boxes.forEach((box)=>{
                    box.innerHTML = `<img src="${img.src}" />` ;
                })
                styles.forEach((s)=> s.classList.remove('active'));
                item.classList.add('active'); 

                let htmlContent = document.querySelector('.m-product-media--slider__images .swiper-slide.swiper-slide-active .product-page-image');
                if(!htmlContent){
                    htmlContent = document.querySelector('.m-product-media--slider__images .swiper-slide .product-page-image');
                }
                let width = htmlContent.offsetWidth;
                let height = htmlContent.offsetHeight;
                
                html2canvas(htmlContent , {
                    useCORS: true, allowTaint: true, backgroundColor:"#f5f5f5",
                    width:1000,height:1000,
                    onrendered: function (canvas) {
                        // Convert the canvas to a data URL representing a PNG image
                        // b64data = canvas.toDataURL();
                        var imgData = canvas.toDataURL('image/png');
                        item.dataset.image =  imgData;
                        console.log("imgData",imgData)

                        // const linkSource = imgData;
                        // const downloadLink = document.createElement("a");
                        // downloadLink.href = linkSource;
                        // downloadLink.download = 'test.png';
                        // downloadLink.click();
                        // // Create an image element and set its source to the data URL
                        // var img = new Image();
                        // img.src = imgData;
        
                        // // Append the image element to the document body or any other element
                        // document.body.appendChild(img);
                    }
                });
            })
        })
    }

    init = () =>{
        this.clickEvent()
        let item = document.querySelector('[name="Color"]:checked');
        if(item){
            item.click();
        }
        
    }

}

if(document.querySelector('.template-product')){
    new ProductPage();
}